/**
 * Business情報からユニークIDを計算する
 */
import hash from 'js-crypto-hash';
import jseu from 'js-encoding-utils';
import { getOrganizationId } from '@/utils/token';

const ID_LENGTH = 16;

const getSHA256 = async (msg: string): Promise<string> => {
  return new Promise((resolve) => {
    hash.compute(jseu.encoder.stringToArrayBuffer(msg), 'SHA-256').then((digest) => {
      resolve(Buffer.from(digest).toString('hex').substr(0, ID_LENGTH));
    });
  });
};

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

/**
 * 長さlengthのランダム文字列の生成
 * @param length 長さ
 */
const getRandomStr = (length = 12) => {
  // Declare all characters
  let str = '';
  for (let i = 0; i < length; i++) {
    str += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return str;
};

/**
 * itemIdの生成関数
 */
const createItemId = () => `P${getRandomStr(16)}`;

/**
 * businessIdの生成関数
 */
const createBusinessId = () => `B${getRandomStr(16)}`;

/**
 * arrivalIdの生成関数
 * TODO: 仕様が固まっていないので、一旦createBusinessIdを参考に実装を行なってみる
 */
const createArrivalId = () => `A${getRandomStr(16)}`;

/**
 *
 * @param entry
 */
const setBusinessId = async (entry: any) => {
  entry.organizationId = await getOrganizationId();
  const idSeed = `${entry.salesDestinationName}|${entry.supplierName}|${entry.deliveryDestinationName}|${entry.businessName}|${entry.form}|${entry.unit}|${entry.endUser}|${entry.note}`;
  entry.businessId = `P${await getSHA256(idSeed)}`;
  // TODO: 要修正
  entry.dataId = `D${getRandomStr(12)}`;
};

export { setBusinessId, createItemId, createBusinessId, createArrivalId, getRandomStr };
